/**
 * Check array is valid or not
 *
 * @param {Array} arr
 * @returns boolean
 */
export const isValidArray = (arr) => {
  return arr && Array.isArray(arr) && arr.length > 0;
};
/**
 * Check array is valid or not
 *
 * @param {String} str
 * @returns boolean
 */
export const isValidString = (str) => {
  return str && typeof str === "string" && str.length > 0;
};

/**
 *
 * @param {Object} obj
 * @returns boolean
 */
export function isValidObject(obj) {
  return obj && Object.keys(obj).length > 0 && obj.constructor === Object;
}


/**
 *  Getting the color on the  basis of status message
 * @param {string} msg 
 * @returns color code;
 */

export const getStatusMessageColor = (msg) => {
  switch(msg){
    case "in progress":
      return "#219653";
    case "completed":
      return "#F2994A";
    case "scheduled":
      return "#2D9CDB";
    case "canceled" :
      return "#EB5757";
    default:
      return "#000000"; 
  }
}